import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";


const ActionItem = ({
  icon,
  title,
  description,
  url,
  onClick,
  iconStyles = {},      
  className = "",       
}) => {

   const navigate = useNavigate();

  const {
    bg = "bg-white",
    color = "text-blue-600",
    hoverBg = "",
  } = iconStyles;


    const handleClick = () => {
    if (url) {
      navigate(url);
    }
  };


  return (
    <div
       onClick={handleClick}
      className={`
        flex items-center justify-between 
        bg-actionitembg
        transition cursor-pointer 
        rounded-xl p-2
        ${className}
      `}
    >
      <div className="flex items-center gap-3">
        {icon && (
          <div
            className={`
              w-8 h-8 flex items-center justify-center 
              rounded-lg shadow-sm
              ${bg} ${color} ${hoverBg}
            `}
          >
            <FontAwesomeIcon icon={icon} />
          </div>
        )}

        <div>
          <p className="text-[12px] font-bold text-textprimary">
            {title}
          </p>

          {description && (
            <p className="text-[10px] text-textsecondary font-normal">
              {description}
            </p>
          )}
        </div>
      </div>

      <span className="text-gray-400 text-[28px]">›</span>
    </div>
  );
};

export default ActionItem;